import { useGetSalaryGuideQuery as useGetSalaryGuide } from '../types'
export default useGetSalaryGuide
